/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 2dMe7XWUq916KsPnra5vYj
// Component: W_Uez__b5a-

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import PermissionRule from "../../components/app-auth/PermissionRule"; // plasmic-import: OKf_hhc2Skl/component
import PermissionRuleGroup from "../../components/app-auth/PermissionRuleGroup"; // plasmic-import: 7jCYJVNv9q/component
import StyleCheckbox from "../../components/style-controls/StyleCheckbox"; // plasmic-import: nZHA7E5OiTx/component
import StyleSelect from "../../components/style-controls/StyleSelect"; // plasmic-import: E0bKgamUEin/component
import IconButton from "../../components/widgets/IconButton"; // plasmic-import: LPry-TF4j22a/component
import Textbox from "../../components/widgets/Textbox"; // plasmic-import: pA22NEzDCsn_/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_end_user_management.css"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/projectcss
import sty from "./PlasmicPermissionsTab.module.css"; // plasmic-import: W_Uez__b5a-/css

import ChevronDownSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: xZrB9_0ir/icon
import CloseSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__CloseSvg"; // plasmic-import: DhvEHyCHT/icon
import SearchSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__SearchSvg"; // plasmic-import: R5DLz11OA/icon

createPlasmicElementProxy;

export type PlasmicPermissionsTab__VariantMembers = {};
export type PlasmicPermissionsTab__VariantsArgs = {};
type VariantPropType = keyof PlasmicPermissionsTab__VariantsArgs;
export const PlasmicPermissionsTab__VariantProps = new Array<VariantPropType>();

export type PlasmicPermissionsTab__ArgsType = {};
type ArgPropType = keyof PlasmicPermissionsTab__ArgsType;
export const PlasmicPermissionsTab__ArgProps = new Array<ArgPropType>();

export type PlasmicPermissionsTab__OverridesType = {
  root?: Flex__<"div">;
  form?: Flex__<"form">;
  notifyCheckbox?: Flex__<typeof StyleCheckbox>;
  input?: Flex__<typeof Textbox>;
  roleSelect?: Flex__<typeof StyleSelect>;
  addBtn?: Flex__<typeof IconButton>;
  columns?: Flex__<"div">;
  mainRules?: Flex__<typeof PermissionRuleGroup>;
};

export interface DefaultPermissionsTabProps {
  className?: string;
}

const $$ = {};

function PlasmicPermissionsTab__RenderFunc(props: {
  variants: PlasmicPermissionsTab__VariantsArgs;
  args: PlasmicPermissionsTab__ArgsType;
  overrides: PlasmicPermissionsTab__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_2dMe7XWUq916KsPnra5vYj",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div className={classNames("all", sty.freeBox__zZaCn)}>
        <div className={classNames("all", "__wab_text", sty.text___71ZHi)}>
          {"Who can log in?"}
        </div>
      </div>
      <form
        data-plasmic-name={"form"}
        data-plasmic-override={overrides.form}
        className={classNames("all", sty.form)}
      >
        <div className={classNames("all", sty.freeBox__nW6I)}>
          <div className={classNames("all", "__wab_text", sty.text__kDdP0)}>
            {"Enter an email, a @domain.com, or a group name"}
          </div>
          <StyleCheckbox
            data-plasmic-name={"notifyCheckbox"}
            data-plasmic-override={overrides.notifyCheckbox}
            className={classNames("__wab_instance", sty.notifyCheckbox)}
          >
            {"Notify users"}
          </StyleCheckbox>
        </div>
        <div className={classNames("all", sty.freeBox___5SwlD)}>
          <Textbox
            data-plasmic-name={"input"}
            data-plasmic-override={overrides.input}
            className={classNames("__wab_instance", sty.input)}
            placeholder={"Add people, groups or @domains..."}
            prefixIcon={
              <SearchSvgIcon
                className={classNames("all", sty.svg__yfl01)}
                role={"img"}
              />
            }
            styleType={["gray"]}
            suffixIcon={
              <CloseSvgIcon
                className={classNames("all", sty.svg__okLgH)}
                role={"img"}
              />
            }
            withIcons={["withPrefix"]}
          />

          <StyleSelect
            data-plasmic-name={"roleSelect"}
            data-plasmic-override={overrides.roleSelect}
            className={classNames("__wab_instance", sty.roleSelect)}
            placeholder={"Role"}
            valueSetState={"isSet"}
          />

          <IconButton
            data-plasmic-name={"addBtn"}
            data-plasmic-override={overrides.addBtn}
            children2={
              <ChevronDownSvgIcon
                className={classNames("all", sty.svg__pbIrE)}
                role={"img"}
              />
            }
            className={classNames("__wab_instance", sty.addBtn)}
            type={["primary"]}
          >
            <div className={classNames("all", "__wab_text", sty.text__qQqcQ)}>
              {"Add"}
            </div>
          </IconButton>
        </div>
      </form>
      <div className={classNames("all", sty.freeBox__h9QS)}>
        <div
          data-plasmic-name={"columns"}
          data-plasmic-override={overrides.columns}
          className={classNames("all", sty.columns)}
        >
          <div className={classNames("all", sty.column__hc3GY)}>
            <div className={classNames("all", "__wab_text", sty.text__saiUl)}>
              {"User or group"}
            </div>
          </div>
          <div className={classNames("all", sty.column__o7NGs)}>
            <div className={classNames("all", "__wab_text", sty.text__yiZe)}>
              {"Role"}
            </div>
          </div>
        </div>
        <PermissionRuleGroup
          data-plasmic-name={"mainRules"}
          data-plasmic-override={overrides.mainRules}
          className={classNames("__wab_instance", sty.mainRules)}
        >
          <PermissionRule
            className={classNames("__wab_instance", sty.permissionRule___83YDq)}
            isGroup={true}
            ruleName={"Anyone @plasmic.app"}
          />

          <PermissionRule
            className={classNames("__wab_instance", sty.permissionRule___1HzCo)}
            hasMenu={true}
            isGroup={true}
            ruleName={"Anyone @plasmic.dev"}
          />

          <PermissionRule
            className={classNames("__wab_instance", sty.permissionRule___1YHz)}
            hasMenu={true}
            isGroup={true}
            ruleName={"Group Admin"}
          />

          <PermissionRule
            className={classNames("__wab_instance", sty.permissionRule__zRPqd)}
            hasMenu={true}
            ruleName={"user@plasmic.app"}
          />

          <PermissionRule
            className={classNames("__wab_instance", sty.permissionRule__tcGvk)}
            isGeneralAccess={true}
            ruleName={"General Access"}
            withoutBorder={true}
          />
        </PermissionRuleGroup>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "form",
    "notifyCheckbox",
    "input",
    "roleSelect",
    "addBtn",
    "columns",
    "mainRules",
  ],
  form: ["form", "notifyCheckbox", "input", "roleSelect", "addBtn"],
  notifyCheckbox: ["notifyCheckbox"],
  input: ["input"],
  roleSelect: ["roleSelect"],
  addBtn: ["addBtn"],
  columns: ["columns"],
  mainRules: ["mainRules"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  form: "form";
  notifyCheckbox: typeof StyleCheckbox;
  input: typeof Textbox;
  roleSelect: typeof StyleSelect;
  addBtn: typeof IconButton;
  columns: "div";
  mainRules: typeof PermissionRuleGroup;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicPermissionsTab__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicPermissionsTab__VariantsArgs;
    args?: PlasmicPermissionsTab__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicPermissionsTab__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicPermissionsTab__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPermissionsTab__ArgProps,
          internalVariantPropNames: PlasmicPermissionsTab__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicPermissionsTab__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPermissionsTab";
  } else {
    func.displayName = `PlasmicPermissionsTab.${nodeName}`;
  }
  return func;
}

export const PlasmicPermissionsTab = Object.assign(
  // Top-level PlasmicPermissionsTab renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    form: makeNodeComponent("form"),
    notifyCheckbox: makeNodeComponent("notifyCheckbox"),
    input: makeNodeComponent("input"),
    roleSelect: makeNodeComponent("roleSelect"),
    addBtn: makeNodeComponent("addBtn"),
    columns: makeNodeComponent("columns"),
    mainRules: makeNodeComponent("mainRules"),

    // Metadata about props expected for PlasmicPermissionsTab
    internalVariantProps: PlasmicPermissionsTab__VariantProps,
    internalArgProps: PlasmicPermissionsTab__ArgProps,
  }
);

export default PlasmicPermissionsTab;
/* prettier-ignore-end */
